__turbopack_context__.v({
  "actionButton": "ContactInquiryPanel-module__9ghq4q__actionButton",
  "bookingLoading": "ContactInquiryPanel-module__9ghq4q__bookingLoading",
  "contactFormAnchor": "ContactInquiryPanel-module__9ghq4q__contactFormAnchor",
  "inquiryPanel": "ContactInquiryPanel-module__9ghq4q__inquiryPanel",
  "modeSwitch": "ContactInquiryPanel-module__9ghq4q__modeSwitch",
  "modeTabs": "ContactInquiryPanel-module__9ghq4q__modeTabs",
  "newBadge": "ContactInquiryPanel-module__9ghq4q__newBadge" + " " + __turbopack_context__.i(262643)["brandchip"],
  "panelBody": "ContactInquiryPanel-module__9ghq4q__panelBody",
  "unconfigured": "ContactInquiryPanel-module__9ghq4q__unconfigured",
  "unconfiguredActions": "ContactInquiryPanel-module__9ghq4q__unconfiguredActions",
  "unconfiguredText": "ContactInquiryPanel-module__9ghq4q__unconfiguredText",
});
